// extracted by mini-css-extract-plugin
module.exports = {"textLabel":"TextLabel_textLabel__1B8Vy","icon":"TextLabel_icon__1dxhn"};